// @flow
import WeekDayPicker from './WeekDayPicker';

export default WeekDayPicker;
